import React, { useEffect, useState } from 'react';

import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { PRODUCT, OFFERT } from '../../types/productType';
import { where } from "firebase/firestore";
import { DOCUMENT_PRODUCT, LISTENER_PRODUCTS } from '../../../shared/types/firestoreType';

import storageManager from '../../../shared/utility/storageManager';

import Cover from './Cover/Index';
import Category from './Category/Index';
import Section from './Section/Index';
import Offert from './Offert/Index';
import Product from './Product/Index';

export default function Index(props) {
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT);

    const [products, setProducts] = useState([]);
    const [offerts, setOfferts] = useState([]);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        const condition = where("visible", "==", true);
        const _products = await storageManager.fetch(LISTENER_PRODUCTS, async () => await productFirestore.getDocuments(condition));
   
        setProducts(_products.filter(m => m.productType === PRODUCT && m.highlighted === true));
        setOfferts(_products.filter(m => m.productType === OFFERT));
    };

    return (
        <>
            <Cover />
            <Category />
            <Section />
            <Offert items={offerts} />
            <Product items={products} />


            {/* <div className="container col-xxl-8 px-4 py-5">
                <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
                    <div className="col-10 col-sm-8 col-lg-6">
                        <img src="https://firebasestorage.googleapis.com/v0/b/uishopdev.appspot.com/o/products%2F56f46135-b493-470a-83fb-4705d8a25480-20220206145446125.webp?alt=media&token=f77644ae-0eec-475e-8e03-a2a9ab92f504" className="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy" />
                    </div>
                    <div className="col-lg-6">
                        <h1 className="display-5 fw-bold lh-1 mb-3">Responsive left-aligned hero with image</h1>
                        <p className="lead">Quickly design and customize responsive mobile-first sites with Bootstrap, the world’s most popular front-end open source toolkit, featuring Sass variables and mixins, responsive grid system, extensive prebuilt components, and powerful JavaScript plugins.</p>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                            <button type="button" className="btn btn-primary btn-lg px-4 me-md-2">Primary</button>
                            <button type="button" className="btn btn-outline-secondary btn-lg px-4">Default</button>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
}